import { RootState } from '..';

export const selectMixtureCandidate = (state: RootState) =>
  state.mixtureCandidates.mixtureCandidate;

export const selectMixtureCandidates = (state: RootState) =>
  state.mixtureCandidates.mixtureCandidates;

export const selectMixtureCandidateErrors = (state: RootState) =>
  state.mixtureCandidates.errors;
